import axiosInstance from "app/axiosInstance";
import { GetPlatformMaintenancesDto } from "../entities/dtos/get-platform-maintenances.dto";

export const getPlatformMaintenances = async () => {
  try {
    const requestData = {
      page: 1,
      where: [
        {
          field: "platforms",
          value: 2 // customer portal
        },
        {
          field: "isDeleted",
          value: false
        }
      ],
      itemsPerPage: 1
    };

    const response = await axiosInstance.post<GetPlatformMaintenancesDto>(
      `/PlatformMaintenances/search`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*"
        }
      }
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      rowCount: 0,
      results: [],
      filters: []
    } as unknown as GetPlatformMaintenancesDto;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
